import axios from "axios";
import "./UserProfile.css";
import Modal from "react-modal";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import { useUserView } from "./useUserView";
import { useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { ReactComponent as Edit } from "../../../../images/icons/edit.svg";
import { ReactComponent as Type } from "../../../../images/icons/type.svg";
import { ReactComponent as Tele } from "../../../../images/icons/tele.svg";
import { ReactComponent as Cost } from "../../../../images/icons/cost1.svg";
import { useSelector, useDispatch } from 'react-redux';
import { ReactComponent as Delete } from "../../../../images/icons/delete.svg";
import React, { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ReactComponent as EmailIcon } from "../../../../images/icons/email.svg";
import { ReactComponent as Company } from "../../../../images/icons/company.svg";
import { ReactComponent as Payment } from "../../../../images/icons/payment.svg";
import { ReactComponent as Clock } from "../../../../images/icons/timer.svg";
import { ReactComponent as LocationIcon } from "../../../../images/icons/location.svg";
import { ReactComponent as JobTitle } from "../../../../images/icons/job-title.svg";
import typeOfContract from "../../../../constants/typeOfContract";
import { ReactComponent as PostalCode } from "../../../../images/icons/postal-code.svg";
import { ReactComponent as PassportlIcon } from "../../../../images/icons/passport.svg";
import { ReactComponent as BirthIcon } from "../../../../images/icons/dat-of-birth.svg";
import TruncateFieldView from "../../../helpers/truncateFieldView";
import profile_image from "../../../../images/user/Default_pfp.png";
import { logout, reset } from "../../../../features/auth/authSlice";
import ChristmasHatGif from "../../../Animations/Christmas/assets/Christmas hat.gif";
import { ReactComponent as UserIcon } from "../../../../images/icons/single-user-icon.svg";
import { ReactComponent as TypeContact } from "../../../../images/icons/type-of-contact.svg";
import CompanyDocumentField from "../../elements/CompanyDocumentField";
import { reset as invoiceReset } from "../../../../features/invoice/invoiceSlice.js";
import { setNotification } from "../../../../features/notification/notificationSlice.js";
import { reset as headerReset } from "../../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../../features/appSettings/appSettingsSlice.js";
import { setUserRoleName } from "../../../../features/users/usersSlice.js";
import EditProfile from "../../../../components/User/UserDetails/UserProfile/UserProfileEdit";
import userTypeName from "../../../../constants/userType";
import userCategoryName from "../../../../constants/userCategory";

// Skeleton loader styles
const skeletonStyle = {
  backgroundColor: "#e5e7eb",
  borderRadius: "4px",
  animation: "pulse 1.5s ease-in-out infinite",
};

// Information Field Skeleton Component
const InformationFieldSkeleton = () => (
  <div className="inner-detail-outer">
    <div className="inner-detail">
      <span className="icon">
        <div
          style={{
            width: "20px",
            height: "20px",
            ...skeletonStyle,
          }}
        />
      </span>
      <div className="inner-detail-inner">
        <div
          style={{
            width: "120px",
            height: "16px",
            ...skeletonStyle,
          }}
        />
      </div>
    </div>
    <div className="inner-detail">
      <span className="icon"></span>
      <div className="inner-detail-inner">
        <div
          style={{
            width: "180px",
            height: "20px",
            ...skeletonStyle,
          }}
        />
      </div>
    </div>
  </div>
);

const ProfileDetails = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [profileEdit, setProfileEdit] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [timeStamp, setTimeStamp] = useState(Date.now());

  const user = useSelector(
    (state) => state.auth.user
  );
  let token = null;
  if (user) {
    if (user && user.token) {
      token = user.token;
    }
  }

  // const { data: userView = [], isLoading, isError: userViewError } = useUserView(props.id, token, profileEdit);

  // useEffect(() => {
  //   if (userView) {
  //     setSelectedUserId(userView?._id);
  //   }
  // }, [timeStamp]);

  const {
    data: userView = [],
    isLoading,
    isError: userViewError,
    refetch
  } = useUserView(props.id, token, profileEdit);

  useEffect(() => {
    // Refetch whenever timeStamp changes
    refetch();

  }, [timeStamp]);



  useEffect(() => {
    const handleUserRole = () => {
      if (userView) {
        if (userView?.role_id?._id === userTypeName.Team_Manager) {
          // Dispatch the action asynchronously without blocking
          dispatch(setUserRoleName(userTypeName.Team_Manager));
        } else {
          // Dispatch the action asynchronously without blocking
          dispatch(setUserRoleName("otheruser"));
        }
      }
    };

    // Call handleUserRole function
    handleUserRole();
  }, [props.id, userView]);

  if (userViewError) {
    if (userViewError.response?.data?.status === "deleted") {
      // Handle the case where the user is deleted
      localStorage.removeItem("user");
      dispatch(logout());
      dispatch(reset());
      dispatch(invoiceReset());
      dispatch(headerReset());
      dispatch(appSettingsReset());
      toast.error('This user is deleted!', {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      navigate("/");
      return;
    }

    if (userViewError.response?.data?.status === "userDeleted") {
      toast.error('This user is deleted!', {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      navigate("/user/myteam/list");
      return;
    }
    // Handle other errors
    console.error("Error fetching user profile");
    toast.error("Error loading user profile. Please try again.", {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      theme: "light",
    });
  }

  const handleDeleteClick = (id) => {
    setSelectedUserId(id);
    setShowConfirmation(true);
  };

  const handleConfirmationOk = async () => {
    try {
      setIsSubmitLoading(true);
      await axios.get(`/api/delete/user/${selectedUserId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success("User removed successfully", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch(setNotification(Date.now()));
      document.body.classList.remove("ReactModal__Body--open");
      navigate("/user/myteam/list");
    } catch (error) {
      console.log('delete error', error);
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        navigate("/");
        return;
      }
      toast.error("Something went wrong while user removal", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      global.config.slackMessage(error.toString());
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const closeModal = () => {
    setShowConfirmation(false);
    setTimeout(() => {
      document.body.classList.remove("ReactModal__Body--open");
    }, 100);
  }

  const downloadCompyDoc = async (compyFile) => {
    try {

      const response = await axios.get(`/api/user/compyDoc/download/${compyFile}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      }, {
        responseType: "blob",
      });
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      saveAs(pdfBlob, `${compyFile}`);

    } catch (error) {

      global.config.slackMessage(error.toString());
      console.error(error);
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error('This user is deleted!', {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      toast.error(`Error Downloading Company DOC`, {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      // Handle error

    }
  };

  const goToEditProfile = (e) => {
    setProfileEdit(true);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${day}/${month}/${year}`;
  };

  const handleCancelEdit = () => {
    setProfileEdit(false);
  };

  // Check if current month is December (0-indexed, so 11 = December)
  const currentMonth = new Date().getMonth();
  const isDecember = currentMonth === 11;

  const pageVariants = {
    initial: { opacity: 0, x: 24 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -24 },
  };

  const pageTransition = { duration: 0.22, ease: "easeInOut" };

  return (
    <AnimatePresence mode="wait">
      {profileEdit ? (
        <motion.div
          key="edit"
          variants={pageVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={pageTransition}
        >
          <EditProfile id={props.id} onCancel={handleCancelEdit} setTimeStamp={setTimeStamp} />
        </motion.div>
      ) : (
        <motion.div
          key="view"
          variants={pageVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={pageTransition}
        >
        <div className="profile-details">
          <div className="profile-photo-outer">
            <div className="profile-photo">
              <div className="profile-photo-inner">
                <div className="profile-photo-sec">
                  {isLoading ? (
                    <div
                      style={{
                        width: "107px",
                        height: "107px",
                        borderRadius: "50%",
                        backgroundColor: "#e5e7eb",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  ) : (
                    <div className="profile-image">
                      {userView.profile_image !== "null" &&
                        userView.profile_image !== null ? (
                        <img
                          src={`/uploads/lowProfileImage/${userView.profile_image}`}
                          alt="User Profile Image"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = profile_image;
                          }}
                        />
                      ) : (
                        <img
                          src={profile_image}
                          alt="User Profile Image"
                        />
                      )}
                    </div>
                  )}
                </div>
                <div className="profile-name">
                  {isLoading ? (
                    <div
                      style={{
                        width: "200px",
                        height: "24px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "4px",
                        animation: "pulse 1.5s ease-in-out infinite",
                        marginBottom: "6px",
                      }}
                    />
                  ) : (
                    <div className="profile-name-sec">
                      {userView?.user_category && [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userView.user_category) ? (
                        <>
                          {userView.company_first_name
                            ? `${userView.company_first_name} ${userView.company_last_name ? userView.company_last_name : ''}`
                            : `${userView.company_name || ''}(Company)`
                          }
                        </>
                      ) : (
                        <>
                          {userView.first_name}{" "}
                          {userView.middle_name && userView.middle_name !== "null"
                            ? userView.middle_name + " "
                            : ""}
                          {userView.last_name}{" "}
                        </>
                      )}
                    </div>
                  )}
                  {isLoading ? (
                    <div
                      style={{
                        width: "120px",
                        height: "19px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "4px",
                        animation: "pulse 1.5s ease-in-out infinite",
                        marginBottom: "12px",
                      }}
                    />
                  ) : (
                    <>
                      {userView.role_id && (
                        <div className="profile-type">
                          {userView.role_id.user_type === "Project Manager" ? "Project manager (Account manager)" : userView.role_id.user_type}
                        </div>
                      )}
                    </>
                  )}
                  <div className="profile-status">
                    {isLoading ? (
                      <div
                        style={{
                          width: "67px",
                          height: "31px",
                          backgroundColor: "#e5e7eb",
                          borderRadius: "100px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    ) : (
                      <>
                        {userView.is_active === false ? (
                          <div className="inactive">
                            Inactive
                          </div>
                        ) : userView.is_active === true ? (
                          <div className="active">
                            Active
                          </div>
                        ) : (
                          userView.is_active
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {isLoading ? (
              <div className="profile-button" style={{ display: "flex", gap: "10px" }}>
                <div
                  style={{
                    width: "132px",
                    height: "44px",
                    backgroundColor: "#e5e7eb",
                    borderRadius: "8px",
                    animation: "pulse 1.5s ease-in-out infinite",
                  }}
                />
                {userView._id !== user._id && (
                  <div
                    style={{
                      width: "100px",
                      height: "44px",
                      backgroundColor: "#e5e7eb",
                      borderRadius: "8px",
                      animation: "pulse 1.5s ease-in-out infinite",
                    }}
                  />
                )}
              </div>
            ) : (
              <div className="profile-button">
                <a onClick={goToEditProfile} className="edit-profile">
                  <span className="bt-ico">
                    <Edit aria-hidden="true" />
                  </span>
                  Edit Profile
                </a>{" "}
                {userView._id !== user._id && (
                  <a
                    className="delete-profile"
                    onClick={() => handleDeleteClick(userView._id)}
                  >
                    <span className="bt-ico">
                      <Delete aria-hidden="true" />
                    </span>
                    Delete
                  </a>
                )}
              </div>
            )}
          </div>

          {showConfirmation && (
            <Modal
              className="delete-modal"
              isOpen={showConfirmation}
              // onRequestClose={() => setShowConfirmation(false)}
              onRequestClose={closeModal}
              contentLabel="Confirmation Delete"
              style={{
                content: {
                  height: "41%",
                  width: "30%",
                  position: "fixed",
                  top: "36%",
                  left: "50%",
                  parent: document.querySelector(".admin-outer.time.tracker"),
                },
              }}
            >
              <div className="delete-modal-content">
                <h2>Confirm Delete</h2>
                <p>
                  Are you sure you want to delete this User?
                </p>
                <div className="delete-modal-buttons">
                  <button className="buttons-rejected" onClick={handleConfirmationOk} disabled={isSubmitLoading}>
                    {isSubmitLoading ?
                      <div className="outter-load-table">
                        <ThreeDots
                          height="18"
                          width="20"
                          radius="9"
                          color="white"
                          ariaLabel="three-dots-loading"
                          wrapperStyle={{}}
                          wrapperClassName=""
                          visible={true}
                        />
                      </div> : "Delete"}
                  </button>
                  <button onClick={closeModal} disabled={isSubmitLoading}>
                    Cancel
                  </button>
                </div>
              </div>
            </Modal>
          )}
          {showSuccessMessage && (
            <div className="success-message">
              Profile deleted successfully!
            </div>
          )}


          <div className="information-outer-section">
            <div className="information-inner">
              <div className="information">
                <div className="information-title">Personal Information</div>
                <div className="information-outer">
                  {isLoading ? (
                    <>
                      <div className="information-left">
                        <InformationFieldSkeleton />
                        <InformationFieldSkeleton />
                        <InformationFieldSkeleton />
                        <InformationFieldSkeleton />
                      </div>
                      <div className="information-right">
                        <InformationFieldSkeleton />
                        <InformationFieldSkeleton />
                        <InformationFieldSkeleton />
                      </div>
                    </>
                  ) : (
                    <>
                  <div className="information-left">
                    {userView.first_name && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <UserIcon aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>First Name</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">{userView.first_name}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    {userView.middle_name && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <UserIcon aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>Middle Name</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">{userView.middle_name}</div>)}
                          </div>
                        </div>
                      </div>
                    )}
                    {userView.last_name && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <UserIcon aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>Last Name</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">{userView.last_name}</div>)}
                          </div>
                        </div>
                      </div>
                    )}
                    {userView.company_name && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <UserIcon aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>Company Name</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">{userView.company_name}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    {userView.company_first_name && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <UserIcon aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>First Name</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">{userView.company_first_name}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    {userView.company_last_name && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <UserIcon aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>Last Name</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">{userView.company_last_name}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    {userView.register_number && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <TypeContact aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>Registration Number</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">{userView.register_number}</div>)}
                          </div>
                        </div>
                      </div>
                    )}
                    {userView.joinedDate && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <BirthIcon aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>Employment Start Date</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              // <div className="value-field">{userView.dob}</div>)}
                              <div className="value-field">{formatDate(userView.joinedDate)}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="information-right">
                    {userView.email && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <EmailIcon aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>Email</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "200px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">{userView.email}</div>)}
                          </div>
                        </div>
                      </div>
                    )}
                    {userView.vat_number && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <TypeContact aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>Vat Id</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">{userView.vat_number}</div>)}
                          </div>
                        </div>
                      </div>
                    )}
                    {userView.dob && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <BirthIcon aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>Date of birth</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              // <div className="value-field">{userView.dob}</div>)}
                              <div className="value-field">{formatDate(userView.dob)}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    {userView.passport_no && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <PassportlIcon aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>Passport or ID Number</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">{userView.passport_no}</div>)}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="information-inner">
              <div className="information">
                <div className="information-title">Account Information</div>
                <div className="information-outer">
                  {isLoading ? (
                    <>
                      <div className="information-left">
                        <InformationFieldSkeleton />
                        <InformationFieldSkeleton />
                        <InformationFieldSkeleton />
                        <InformationFieldSkeleton />
                      </div>
                      <div className="information-right">
                        <InformationFieldSkeleton />
                        <InformationFieldSkeleton />
                        <InformationFieldSkeleton />
                        <InformationFieldSkeleton />
                      </div>
                    </>
                  ) : (
                    <>
                  <div className="information-left">
                    {userView.user_category && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <Type aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>User Category</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">
                                {userView.user_category === userCategoryName.Individual
                                  ? "Individual"
                                  : userView.user_category === userCategoryName.Business
                                    ? "Business"
                                    : userView.user_category === userCategoryName.Vendor
                                      ? "Vendor"
                                      : userView.user_category === userCategoryName.Client
                                        ? "Client"
                                        : ""
                                }
                              </div>)}
                          </div>
                        </div>
                      </div>
                    )}
                    {userView.role_id && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <Type aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>Type of Account</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">{userView.role_id.user_type === "Project Manager" ? "Project manager (Account manager)" : userView.role_id.user_type}</div>)}
                          </div>
                        </div>
                      </div>
                    )}
                    {userView.department && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <Type aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>Department</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">{userView.department.user_department}</div>)}
                          </div>
                        </div>
                      </div>
                    )}
                    {userView.job_title && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <JobTitle aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>Job Title</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">
                                {userView.job_title}
                              </div>)}
                          </div>
                        </div>
                      </div>
                    )}
                    {userView.user_wx_comapny && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <Company aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>Company</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">{userView.user_wx_comapny.wx_company}</div>)}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="information-right">
                    {userView.typeOfContract && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <TypeContact aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>Type of contract</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">{userView.typeOfContract.typeOfContract}</div>)}
                          </div>
                        </div>
                      </div>
                    )}

                    {userView.monthly_hours && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <Clock aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>Total Hours</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">{userView.monthly_hours}</div>)}
                          </div>
                        </div>
                      </div>
                    )}

                    {userView.payment_currency && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <Payment aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>Payment Currency</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">{userView.payment_currency}</div>)}
                          </div>
                        </div>
                      </div>
                    )}

                    {(user.userType === 1 || user.userType === 2) && userView.cost > 0 && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <Cost aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            {userView.typeOfContract?._id ===
                              typeOfContract.Hourly_Rate ? (
                              <label>Compensation per Hour ({userView.payment_currency})</label>
                            ) : (
                              <label>Compensation ({userView.payment_currency})</label>
                            )}
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">{userView.cost}</div>)}
                          </div>
                        </div>
                      </div>
                    )}

                    {(user.userType === 1 || user.userType === 2) && userView.overhead_cost > 0 && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <Cost aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>Overhead cost per Hour ({userView.payment_currency})</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">{userView.overhead_cost}</div>)}
                          </div>
                        </div>
                      </div>
                    )}


                    {userView.vat > 0 && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <TypeContact aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>VAT (%)</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">{userView.vat}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    {userView.company_document && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <TypeContact aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>Company Document</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div style={{ cursor: "pointer" }} onClick={() => downloadCompyDoc(userView.company_document)}>
                                <CompanyDocumentField companyDocument={userView.company_document} />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {(isLoading || userView.city || userView.state || userView.country || userView.address || userView.pincode || userView.mobile_no) && (
            <div className="information-inner">
              <div className="information">
                <div className="information-title">Address</div>
                <div className="information-outer">
                  {isLoading ? (
                    <>
                      <div className="information-left">
                        <InformationFieldSkeleton />
                        <InformationFieldSkeleton />
                        <InformationFieldSkeleton />
                        <InformationFieldSkeleton />
                      </div>
                      <div className="information-right">
                        <InformationFieldSkeleton />
                        <InformationFieldSkeleton />
                      </div>
                    </>
                  ) : (
                    <>
                  <div className="information-left">
                    {userView.city && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <LocationIcon aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>City</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">{userView.city}</div>)}
                          </div>
                        </div>
                      </div>
                    )}

                    {userView.state && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <LocationIcon aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>State</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">{userView.state}</div>)}
                          </div>
                        </div>
                      </div>
                    )}


                    {userView.country && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <LocationIcon aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>Country</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">{userView.country}</div>)}
                          </div>
                        </div>
                      </div>
                    )}
                    {userView.address && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <LocationIcon aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>Address</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "200px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field"><TruncateFieldView textContent={userView.address} /></div>)}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="information-right">
                    {userView.pincode && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <PostalCode aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>Postal Code</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">{userView.pincode}</div>)}
                          </div>
                        </div>
                      </div>
                    )}
                    {userView.mobile_no && (
                      <div className="inner-detail-outer">
                        <div className="inner-detail">
                          <span className="icon">
                            <Tele aria-hidden="true" />
                          </span>
                          <div className="inner-detail-inner">
                            <label>Mobile No.</label>
                          </div>
                        </div>
                        <div className="inner-detail">
                          <span className="icon"></span>
                          <div className="inner-detail-inner">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "20px",
                                  backgroundColor: "#e5e7eb",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            ) : (
                              <div className="value-field">{userView.mobile_no}</div>)}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            )}
          </div>
        </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ProfileDetails;